import { COMMA, ENTER } from '@angular/cdk/keycodes';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Inject,
  OnInit,
  ViewChild,
} from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { BehaviorSubject, Observable } from 'rxjs';
import { ContactsService } from 'src/app/core/lists/_services';
import { TranslateService } from '@ngx-translate/core';
import { CommunicationsService } from 'src/app/core/timeline/_services';
import {
  LayoutUtilsService,
  MessageType,
} from 'src/app/core/_base/crud/utils/layout-utils.service';
import { select, Store } from '@ngrx/store';
import { AppState } from 'src/app/core/reducers';
import { currentUser } from 'src/app/core/auth';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogConfig,
  MatDialogRef,
} from '@angular/material/dialog';
import { CommunicationService } from '../../../../../core/services/communication.service';
import { GeneralAutocompleteComponent } from '../../../../partials/layout/general-autocomplete/general-autocomplete.component';
import { SelectEntitiesDialogComponent } from '../../../../partials/content/general/select-entities-dialog/select-entities-dialog.component';
import { StringUtilsService } from '../../../../../core/services/string-utils.service';
import { InboxService } from '../../../../../core/events';

@Component({
  selector: 'kt-send-email-fax',
  templateUrl: './send-email-fax.component.html',
  styleUrls: ['./send-email-fax.component.scss'],
})
export class SendEmailFaxComponent implements OnInit, AfterViewInit {
  separatorKeysCodes: number[] = [ENTER, COMMA];
  recipientCtrl = new FormControl();
  topicCtrl = new FormControl();
  tags = new FormControl();
  filteredTopics: Observable<any[]>;
  recipients = [];
  relatedList = [];
  topics = [];
  communicationType;
  files = [];
  failed: string[] = [];
  attachments: string[] = [];
  senderName: string;
  hasFormErrors: boolean;
  emailFaxForm: FormGroup;
  sendDocs: boolean;
  selectedInboxType;
  editorOptions = {
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'], // toggled buttons
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      [{ list: 'ordered' }, { list: 'bullet' }],
      ['clean'], // remove formatting button
    ],
  };
  editorStyle = {
    height: '200px',
    backgroundColor: '#ffffff',
  };
  formatNewTopicFn = (value) => {
    return value;
  };

  filterTopicFn = (value) => {
    return value?.topic || '';
  };

  getDocs = this.communicationsService.getDocs.bind(this.communicationsService);
  searchContacts = this.contactsService.searchContacts.bind(this.contactsService);
  inboxAutocompleteCall;
  @ViewChild('inboxAutocomplete') inboxAutocomplete: GeneralAutocompleteComponent;
  @ViewChild('recipientInput') recipientInput: ElementRef<HTMLInputElement>;
  @ViewChild('topicInput') topicInput: ElementRef<HTMLInputElement>;
  @ViewChild('fileInput') fileInput: ElementRef;
  @ViewChild('topicAutocomplete') topicAutocomplete;
  showFileLoader = new BehaviorSubject(false);
  totalFileSize = 1;
  uploadRequests: any[];
  clicked = false;
  callback;
  filteredview = false;
  reply;
  messageId;
  fromSent;
  inboxDisabled = true;

  ngOnInit() {
    this.filteredview = this.data.filteredView;
    this.sendDocs = this.data.sendDocs;
    this.reply = this.data.reply;
    this.messageId = this.data.messageId;
    this.fromSent = this.data.sent;
    this.communicationType = this.data.communicationType;
    if (this.reply) {
      this.communicationType = this.data.communicationType;
      if (this.communicationType === 'FAX') {
        this.inboxAutocompleteCall = this.communicationService.loadAllInboxesWithFax.bind(
          this.communicationService,
        );
      } else if (this.communicationType === 'EMAIL') {
        this.inboxAutocompleteCall = this.communicationService.loadAllInboxes.bind(
          this.communicationService,
        );
      }
    }
    this.createForm();
  }

  ngAfterViewInit(): void {
    if (this.data.document) {
      setTimeout(() => {
        this.topicAutocomplete.setValue([this.data.document]);
        this.topicAutocomplete.updateValueAndValidity();
      });
    }

    if (this.filteredview)
      setTimeout(() => {
        const value = [this.data.email];
        const newObj = value.map((val) => {
          return {
            id: val.id,
            email: val.email,
            type: 'CONTACT',
            name: val.first_name + ' ' + val.last_name,
          };
        });
        this.recipients = newObj;
        this.emailFaxForm.get('recipients').setValue(this.recipients);
        this.recipientCtrl.setValue(null);
      }, 50);
  }

  constructor(
    public dialogRef: MatDialogRef<SendEmailFaxComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private emailFaxFB: FormBuilder,
    private contactsService: ContactsService,
    private communicationsService: CommunicationsService,
    private translate: TranslateService,
    private layoutUtilsService: LayoutUtilsService,
    private cdr: ChangeDetectorRef,
    private store: Store<AppState>,
    public dialog: MatDialog,
    private communicationService: CommunicationService,
    public stringUtils: StringUtilsService,
    private inboxService: InboxService,
  ) {
    this.store
      .pipe(select(currentUser))
      .subscribe((res) => (this.senderName = res && res.fullName ? res.fullName : ''));
  }

  removeTopic(topic): void {
    const index = this.topics.indexOf(topic);
    if (index >= 0) {
      this.topics.splice(index, 1);
    }
  }

  selectedTopic(value): void {
    this.topics = value;
    this.topicCtrl.setValue(null);
  }

  onFileChange(event) {
    this.attachments = [];
    this.files = [];
    for (const file of event.target.files) {
      this.attachments.push(file.name);
      this.files.push(file);
    }
  }

  sendA() {
    const controls = this.emailFaxForm.controls;
    const inbox = controls.inbox.value ? { id: controls.inbox.value.id } : null;
    const inboxRequest = {
      communication_type: this.communicationType,
      body: {
        subject: controls.subject.value,
        body: controls.body.value,
        attachment_names: this.attachments,
        receivers: controls.recipients.value,
        sender_name: this.senderName,
        tags: this.tags.value,
        inbox,
        related_to_list: controls.related_to.value,
      },
    };
    this.communicationsService.sendEmailFax(inboxRequest).subscribe((res) => {
      if (res.data) {
        if (this.files.length === 0) {
          // tslint:disable-next-line:max-line-length
          this.layoutUtilsService.showActionNotification(
            this.translate.instant('EMAIL_FAX.SUCCESS'),
            MessageType.Update,
            3000,
            false,
            false,
          );
          this.dialogRef.close();
        }
        const obs = [];
        const uuids = res.data.pre_signed_urls.map((x) => x.uuid);
        // tslint:disable-next-line:prefer-for-of
        for (let i = 0; i < this.files.length; i++) {
          obs.push(
            this.communicationsService.uploadFiles(res.data.pre_signed_urls[i].url, this.files[i]),
          );
          this.totalFileSize += this.files[i].size;
        }
        this.uploadRequests = obs;
        this.callback = this.sendFiles.bind(this, res.data.id, uuids);
        this.showFileLoader.next(true);
      }
    });
  }

  sendB() {
    const controls = this.emailFaxForm.controls;
    const request = {
      communication_type: this.communicationType,
      body: {
        subject: controls.subject.value,
        body: controls.body.value,
        uuids: this.topics.map((topic) => topic.uuid),
        receivers: controls.recipients.value,
        sender_name: this.senderName,
        tags: this.tags.value,
      },
    };
    this.communicationsService.sendDocuments(request).subscribe((res) => {
      if (res.data) {
        this.sendFiles(res.data.id, request.body.uuids);
      } else {
        // tslint:disable-next-line:max-line-length
        this.layoutUtilsService.showActionNotification(
          this.translate.instant('GLOBAL.UNSPECIFIED_ERROR'),
          MessageType.Update,
          3000,
          false,
          false,
        );
      }
    });
  }

  upload(url, file) {
    return this.communicationsService.uploadFiles(url, file);
  }

  sendFiles(id: string, uuids: string[]) {
    const communicationType = this.fromSent ? 'communication' : 'received_communication';
    const sendFilesObservable = this.reply
      ? this.communicationsService.sendFilesFromReplies(
          this.messageId,
          uuids,
          communicationType,
          id,
        )
      : this.communicationsService.sendFilesFromInbox(id, uuids, communicationType);

    sendFilesObservable.subscribe((res) => {
      const successMessage = this.translate.instant('EMAIL_FAX.SUCCESS');
      const errorMessage = this.translate.instant('GLOBAL.UNSPECIFIED_ERROR');
      const message = res === null ? successMessage : errorMessage;

      this.layoutUtilsService.showActionNotification(
        message,
        MessageType.Update,
        3000,
        false,
        false,
      );
      if (res === null) this.dialogRef.close();
    });
  }

  getTitle(): string {
    if (this.reply) {
      return 'Reply';
    }
    if (this.communicationType === 'DOCUMENT') {
      return 'Compose Document';
    }
    return 'New Message';
  }

  close() {
    this.dialogRef.close();
  }

  resetFileInput() {
    this.attachments = [];
    this.files = [];
    this.fileInput.nativeElement.value = [];
  }

  isControlHasError(controlName: string, validationType: string): boolean {
    const control = this.emailFaxForm.controls[controlName];
    if (!control) {
      return false;
    }
    const result = control.hasError(validationType) && (control.dirty || control.touched);
    return result;
  }

  chipListValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      return !control.value || control.value.length === 0 ? { chipListRequiredError: true } : null;
    };
  }

  createForm() {
    this.emailFaxForm = this.emailFaxFB.group({
      recipients: [[], this.chipListValidator()],
      subject: ['', Validators.required],
      entityType: ['', Validators.required],
      body: [''],
      inbox: [],
      related_to: [[]],
    });
  }

  replyTo() {
    const controls = this.emailFaxForm.controls;
    const emailRequest = {
      body: controls.body.value.toString(),
      attachment_names: this.attachments,
      sender_name: this.senderName,
    };
    const communication_type = this.fromSent ? 'communication' : 'received_communication';
    this.inboxService
      .sendReply(communication_type, this.messageId, emailRequest)
      .subscribe((res) => {
        if (res.data) {
          this.reply = res.data;
          if (this.files.length === 0) {
            // tslint:disable-next-line:max-line-length
            this.layoutUtilsService.showActionNotification(
              this.translate.instant('EMAIL_FAX.SUCCESS'),
              MessageType.Update,
              3000,
              false,
              false,
            );
            this.dialogRef.close();
          }
          const obs = [];
          const uuids = res.data.pre_signed_urls.map((x) => x.uuid);
          // tslint:disable-next-line:prefer-for-of
          for (let i = 0; i < this.files.length; i++) {
            obs.push(
              this.communicationsService.uploadFiles(
                res.data.pre_signed_urls[i].url,
                this.files[i],
              ),
            );
            this.totalFileSize += this.files[i].size;
          }
          this.uploadRequests = obs;
          this.callback = this.sendFiles.bind(this, res.data.id, uuids);
          this.showFileLoader.next(true);
        }
      });
  }

  submit() {
    this.hasFormErrors = false;
    const controls = this.emailFaxForm.controls;
    if (this.communicationType === 'FAX') this.inboxAutocomplete.updateValueAndValidity();
    if (this.sendDocs) {
      this.emailFaxForm.controls['entityType'].clearValidators();
      this.emailFaxForm.controls['entityType'].updateValueAndValidity();
      this.topicAutocomplete.updateValueAndValidity();
    }
    if (this.emailFaxForm.invalid) {
      Object.keys(controls).forEach((controlName) => controls[controlName].markAsTouched());
      this.hasFormErrors = true;
      return;
    }
    this.clicked = true;
    if (this.sendDocs) {
      this.sendB();
    } else {
      this.sendA();
    }
  }

  callbackOnFileLoad() {
    this.callback();
  }

  filterInboxFn(event: any): string {
    return event ? event.name : '';
  }

  onInboxChange(val) {
    this.emailFaxForm.controls.inbox.setValue(val);
    this.emailFaxForm.controls.inbox.updateValueAndValidity();
  }

  openSelectEntitiesDialog(source) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.closeOnNavigation = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = '800px';
    dialogConfig.data = {
      source: source === 1 ? 'COMMUNICATION-RECIPIENT' : 'COMMUNICATION-RELATED',
      entities: source === 1 ? this.recipients.slice() : this.relatedList.slice(),
      filterFn:
        source === 1 ? this.filterReceiverAutocomplete.bind(this, this.communicationType) : null,
    };
    const dialogRef = this.dialog.open(SelectEntitiesDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        const resultSet = res.map((obj) => {
          let name = '';
          if (obj.first_name) {
            name += obj.first_name;
          }
          if (obj.last_name) {
            name += ' ' + obj.last_name;
          }
          const result =
            source === 1
              ? {
                  id: obj.entity_id,
                  email: this.communicationType === 'FAX' ? obj.fax : obj.email,
                  type: this.getObjectType(obj.type),
                  name,
                }
              : {
                  id: obj.entity_id,
                  email: obj.email ? obj.email : '',
                  related_type: obj.type === 'CONTACT' ? 'CONTACT' : 'ENTITY',
                  name,
                };
          return result;
        });
        source === 1 ? (this.recipients = res) : (this.relatedList = res);
        source === 1
          ? this.emailFaxForm.get('recipients').setValue(resultSet)
          : this.emailFaxForm.get('related_to').setValue(resultSet);
      }
    });
  }

  getObjectType(type) {
    if (type === 'DOCTOR' || type === 'FACILITY' || type === 'PHARMACY' || type === 'PATIENT') {
      return 'ENTITY';
    }
    if (type === 'CONTACT') {
      return 'CONTACT';
    }
    return 'INSURANCE';
  }

  optionFormatter(obj) {
    if (!obj) return '';
    let subTitle = '';
    if (
      this.data.communicationType.localeCompare('EMAIL') === 0 ||
      this.data.communicationType.localeCompare('DOCUMENT') === 0
    ) {
      subTitle = obj.email ? obj.email : '';
    }
    if (this.data.communicationType.localeCompare('FAX') === 0) {
      subTitle = obj.fax ? obj.fax : '';
    }
    return `<div>${obj.name} <small class="text-muted">${subTitle}</small></div>`;
  }

  filterReceiverAutocomplete(type: string, resultSet: Array<any>) {
    return resultSet.filter((obj) => {
      if (type === 'EMAIL') {
        return (
          obj.email !== null &&
          obj.email !== undefined &&
          obj.email.match(/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/) !== null
        );
      }
      return obj.fax !== null && obj.fax !== undefined && obj.fax.match(/^[0-9]{10}$/) !== null;
    });
  }

  emptyEntities() {
    this.inboxDisabled = false;
    this.communicationType = this.selectedInboxType;
    if (this.selectedInboxType === 'EMAIL') {
      this.inboxAutocompleteCall = this.communicationService.loadAllInboxes.bind(
        this.communicationService,
      );
    } else {
      this.inboxAutocompleteCall = this.communicationService.loadAllInboxesWithFax.bind(
        this.communicationService,
      );
    }
  }
}
